<div class="layout-wrapper layout-content-navbar bg-white">
  <div class="layout-container">
    
    <!-- Side Nav -->
    <app-side-nav></app-side-nav>

    <!-- Main Content -->
    <div class="container-fluid mt-3">

      <!-- Header Row -->
      <div class="row align-items-center mb-4">
        <div class="col-md-6 col-12 text-md-start text-center mb-2 mb-md-0">
          <h4 class="study-heading">
            <span class="text-muted fw-light">Study Management /</span> Study List
          </h4>
        </div>

        <div class="col-md-6 col-12 text-md-end text-center">
          <button type="button"
                  class="btn custom-button"
                  (click)="openCreateStudyModal()">
            Create Study
          </button>
        </div>
      </div>

      <!-- Filters -->
      <div class="row g-3 mb-3">
        <div class="col-lg-4 col-md-4 col-sm-6 col-12">
          <input type="text"
                 class="form-control filter-input"
                 placeholder="Search by Study"
                 [(ngModel)]="searchName" />
        </div>

        <div class="col-lg-3 col-md-4 col-sm-6 col-12">
          <input type="text"
                 class="form-control filter-input"
                 placeholder="Search by Assigned By"
                 [(ngModel)]="assignedBy" />
        </div>

        <div class="col-lg-3 col-md-4 col-sm-6 col-12">
          <select class="form-select filter-input cursor-pointer" [(ngModel)]="statusFilter">
            <option value="" selected hidden>Filter By Status</option>
            <option value="1">Active</option>
            <option value="0">Inactive</option>
          </select>
        </div>

        <div class="col-lg-2 col-md-12 col-sm-12 col-12 d-flex gap-2">
          <button class="btn custom-button w-50" (click)="searchUsers()">Search</button>
          <button class="btn custom-button w-50" (click)="clear()">Clear</button>
        </div>
      </div>

      <!-- Spinner -->
      <div *ngIf="loading" class="d-flex justify-content-center align-items-center spinner-area">
        <div class="spinner-border text-purple" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <!-- Table -->
      <div class="card mt-3" *ngIf="!loading">
        <div class="table-responsive rounded">
          <table class="table table-hover align-middle">
            <thead>
              <tr>
                <th>Study</th>
                <th>Date Assigned</th>
                <th>Completion Date</th>
                <th>Assigned By</th>
                <th>Template</th>
                <th>Status</th>
                <th class="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let user of users">
                <td><a>{{ user.study_name }}</a></td>
                <td>{{ user.date_assigned }}</td>
                <td>{{ user.completion_date }}</td>
                <td>{{ user.assigned_by }}</td>
                <td>{{ getTemplateName(user) }}</td>
                <td>
                  <span class="badge bg-label-primary">
                    {{ user.is_active == 1 ? "Active" : "Inactive" }}
                  </span>
                </td>
                <td class="text-center">
                  <div class="dropdown">
                    <button class="btn p-0 dropdown-toggle" data-bs-toggle="dropdown">
                      <i class="bx bx-dots-vertical-rounded"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end custom-dropdown-menu">
                      <li>
                        <a class="dropdown-item cursor-pointer" (click)="openEditModal(user)">
                          <i class="bx bx-edit-alt me-1"></i>Edit
                        </a>
                      </li>

                      <li>
                        <a class="dropdown-item cursor-pointer" (click)="disableStudy(user.id, !user.is_active)">
                          <i class="bx" [ngClass]="user.is_active ? 'bx-pause-circle' : 'bx-play-circle'"></i>
                          {{ user.is_active ? 'Inactive' : 'Active' }}
                        </a>
                      </li>

                      <li>
                        <a class="dropdown-item cursor-pointer" (click)="deleteStudy(user.id)">
                          <i class="bx bx-trash me-1"></i>Delete
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Pagination -->
      <div class="row mt-4">
        <div class="col text-center">
          <nav>
            <ul class="pagination justify-content-center flex-wrap cursor-pointer">
              <li class="page-item mx-2" [class.disabled]="shouldDisablePrevious()">
                <a class="page-link" (click)="prevPage()">Previous</a>
              </li>

              <li *ngFor="let page of pageRange"
                  class="page-item mx-2"
                  [class.active]="page === currentPage">
                <a class="page-link" (click)="goToPage(page)">
                  {{ page }}
                </a>
              </li>

              <li class="page-item" [class.disabled]="shouldDisableNext()">
                <a class="page-link" (click)="nextPage()">Next</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>

    </div>
  </div>
</div>


<!-- Modal -->
<div class="modal fade show d-block custom-modal" *ngIf="showCreateStudyModal" (click)="closeCreateStudyModal()">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content p-3" (click)="closeSiteLocationDropdown()">

      <h5 class="modal-title">
        {{ isEditMode ? 'Edit Study' : 'Create New Study' }}
      </h5>

      <form [formGroup]="studyForm">

        <!-- Template -->
        <div class="mb-3">
          <label class="form-label">Select Template:</label>
          <select class="form-select cursor-pointer" formControlName="selectedTemplate">
            <option [ngValue]="null" disabled>Select Template</option>
            <option *ngFor="let template of templatesList" [ngValue]="template">
              {{ template.item_text }}
            </option>
          </select>
          <div class="text-danger" *ngIf="validationMessage1">{{ validationMessage1 }}</div>
        </div>

        <!-- Study Name -->
        <div class="mb-3">
          <label class="form-label">Study Name:</label>
          <input type="text" class="form-control"
                 formControlName="studyName"
                 placeholder="Enter study name"
                 [disabled]="isEditMode" />
          <div class="text-danger" *ngIf="validationMessage2">{{ validationMessage2 }}</div>
        </div>

        <!-- Study Code -->
        <div class="mb-3">
          <label class="form-label">Study Code:</label>
          <input type="text" class="form-control"
                 formControlName="studyCode"
                 placeholder="Enter study code"
                 [disabled]="isEditMode" />
          <div class="text-danger" *ngIf="validationMessage3">{{ validationMessage3 }}</div>
        </div>

        <!-- Site Locations -->
        <div class="mb-3 position-relative site-location-dropdown-container">
          <label class="form-label">Select Site Locations:</label>

          <!-- Selected Chips -->
          <div class="selected-site-container mb-2" *ngIf="studyForm.get('selectedSiteLocations')?.value?.length > 0" (click)="$event.stopPropagation()">
            <div class="selected-site-row">
              <div class="site-selected-item"
                   *ngFor="let selectedSite of studyForm.get('selectedSiteLocations')?.value">
                <span class="site-selected-name">{{ selectedSite.item_text }}</span>
                <button type="button"
                        class="site-remove-btn"
                        (click)="removeSelectedSiteLocation(selectedSite)">×</button>
              </div>
            </div>
          </div>

          <!-- Dropdown trigger -->
          <div class="custom-dropdown-trigger" (click)="toggleSiteLocationDropdown(); $event.stopPropagation()">
            <span>
              {{ studyForm.get('selectedSiteLocations')?.value?.length ? 'Add more site locations...' : 'Select Site Locations' }}
            </span>
            <i class="bx bx-chevron-down"></i>
          </div>

          <!-- Dropdown -->
          <div *ngIf="showSiteLocationDropdown" class="custom-dropdown-list" (click)="$event.stopPropagation()">
            <div class="dropdown-header">
              <input type="text"
                     class="form-control form-control-sm"
                     placeholder="Search site locations..."
                     [value]="siteLocationSearchTerm"
                     (input)="siteLocationSearchTerm = $event.target.value; filterSiteLocations()"
                     (click)="$event.stopPropagation()">
            </div>

            <div class="dropdown-items">
              <div *ngFor="let site of filteredSiteLocations"
                   class="dropdown-item-custom"
                   [class.selected]="isSiteLocationSelected(site)"
                   (click)="selectSiteLocation(site); $event.stopPropagation()">
                {{ site.item_text }}
              </div>
            </div>
          </div>

          <div class="text-danger" *ngIf="validationMessage4">{{ validationMessage4 }}</div>
        </div>

        <div class="text-end mt-3">
          <button type="button" class="btn custom-button me-2" (click)="closeCreateStudyModal()">Cancel</button>
          <button class="btn custom-button" (click)="onCreate()" [disabled]="!studyForm.valid">
            {{ isEditMode ? 'Update' : 'Create' }}
          </button>
        </div>

      </form>
    </div>
  </div>
</div>
